import React from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../routes/routeName'
import StateComponents from '../../../components/state-component/StateComponents'
import TableCustom from '../../../components/table/tableCustom'
import { debouncedApiCall } from '../../../utils/app.utils'
import { IconComponent } from '../../../assets/icons/iconComponent'
import ContainerButton from '../../../components/button/ContainerButton'
import ManageStateComplaintType from './manageStateComplaintType'
import ModalCustom from '../../../components/modal/ModalCustom'
import { useTranslation } from 'react-i18next'

type Props = {}

const ComplaintType: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setSearch,
        handleDownloadReport,
        showModal,
        handleCloseModal,
        complaints_type_form,
        set_complaints_type_form,
        handleSubmitForm,
        setShowModal
    } = ManageStateComplaintType()
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("COMPLAINTS_MANAGE_CATEGORY")}
                hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("COMPLAINTS_COMPLAINT_SYSTEM"),
                                disabled_match: true,
                                pathName: ""
                            },
                            {
                                key: "complaintSubmit",
                                name: t("COMPLAINTS_MANAGE_CATEGORY"),
                                pathName: routeName.cms.complaintsType
                            },
                        ]}
                    />
                }
                buttonContent={
                    <ContainerButton
                        justifyContent='flex-end'
                        buttonData={[
                            {
                                buttonProps: {
                                    onClick: handleDownloadReport
                                },
                                key: "DOWNLOAD_CSV",
                                label: t("COMPLAINTS_DOWNLOAD_CSV"),
                                seq: 1,
                                type: "DOWNLOAD_CSV"
                            }
                        ]}
                    />
                }
                content={
                    <div className='w-full'>
                        <div className='w-full gap-4 flex justify-between flex-col md:flex-row flex-wrap md:flex-nowrap items-center'>
                            <span className='flex-1'>
                                <StateComponents
                                    otherProps={{ spacing: 2 }}
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 6
                                            },
                                            fieldProps: {
                                                placeholder: t("COMPLAINTS_SEARCH_CATEGORY_NAME"),
                                                startAdornment: <IconComponent.SearchIcon />,
                                                onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearch }),
                                            }
                                        },
                                    ]}
                                />
                            </span>
                            <span className='w-full md:w-auto'>
                                <ContainerButton
                                    buttonData={[
                                        {
                                            seq: 1,
                                            key: "ADD",
                                            buttonProps: {
                                                onClick: () => setShowModal("ADD")
                                            },
                                            label: t("COMPLAINTS_ADD_CATEGORY"),
                                            type: "ADD"
                                        }
                                    ]}
                                />
                            </span>

                        </div>


                        <div className='mt-10'>
                            <section className='w-full mt-10'>
                                <TableCustom
                                    tableMinWidth={1440}
                                    tableFixedWidth
                                    customScroll
                                    page={page}
                                    pageLimit={pageLimit}
                                    sortBy={sortBy}
                                    sortType={sortType}
                                    headCells={headCells}
                                    rowCount={totalItems}
                                    rowsData={data?.map((data: any, i: any) => {
                                        return renderData(data, i)
                                    })}
                                    onSort={handleRequestSort}
                                    setPageLimit={(value: number) => setPageLimit(value)}
                                    setPage={(value: number) => setPage(value)}
                                />
                            </section>
                        </div>
                    </div>
                }
            />

            {showModal !== '' && (
                <ModalCustom
                    open
                    title={showModal === 'ADD' ? t("COMPLAINTS_CREATE_CATEGORY") : t("COMPLAINTS_COMPLAINT_CATEGORY")}
                    subTitle={t("COMPLAINTS_PLEASE_PROVIDE_COMPLETE_DETAILS")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !complaints_type_form.complaints_type_name,
                        hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => handleSubmitForm()
                    }}
                    component={
                        <div className='w-full'>
                            <StateComponents
                                disabledAllField={showModal === 'VIEW'}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            heading: t("COMPLAINTS_CATEGORY_NAME"),
                                            required: true,
                                            value: complaints_type_form.complaints_type_name,
                                            onChange: (e) => set_complaints_type_form((prev) => ({ ...prev, complaints_type_name: e.target.value }))
                                        }
                                    }
                                ]}
                            />
                        </div>
                    }
                />
            )}
        </div>
    )
}

export default ComplaintType